import {ValidatorFn, AbstractControl} from '@angular/forms';
export function selectValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
      const selected = control.value;
      return selected.length === 0 ? {'invalidSelect': {selected}} : null;
    };
}
